import { render } from "./LoadingSpinnerIcon.vue?vue&type=template&id=3a8b8a1b&scoped=true"
const script = {}

import "./LoadingSpinnerIcon.vue?vue&type=style&index=0&id=3a8b8a1b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8b8a1b"]])

export default __exports__